const AppendParams = (url, params) => {
  const connector = url.includes('?') ? '&' : '?'

  return `${url}${connector}${params}`
}

export default AppendParams
